<template>
  <main class="register-page activate-page" role="main">
    <vue-loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></vue-loading>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-5 activate-section">
        <div class="wizard-container" v-if="!isLoading">
          <vue-good-wizard
            ref="wizard"
            :onNext="nextClick"
            :onBack="backClick"
            :steps="registerSteps"
          >
            <div slot="otp">
              <div class="container activate">
                <h1 class="section-title">Register</h1>                
                <vue-otp @response="validOtp" action="account_create"></vue-otp>
              </div>
            </div>
            <div slot="customer-details">
              <customer-details
                @cancel="cancel"
                @clear-subscriber="resetSubscriber"
                @valid-subscriber="updateSubscriber"                
                :subscriber.sync="subscriber"
              ></customer-details>
            </div>
            <div slot="rica-details">
              <rica-details
                @updated="ricaSubscriber"
                :subscriber="subscriber"
              ></rica-details>
            </div>
            <div slot="complete">
              <complete @cancel="cancel" @completed="completeRegistration" :mobile="subscriber.mobile_number" :order_id="subscriber.id"></complete>
            </div>
          </vue-good-wizard>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-7 image-section">
        <img
          class="img-fluid"
          src="/assets/images/backgrounds/me-you-activation-image.jpg"
          alt="Acivation-Input-Image"
        />
      </div>
    </div>
  </main>
</template>

<script>
import { GoodWizard } from "vue-good-wizard";
import EventBus from '@/components/shared/event-bus';
import VueOtp from "@/components/elements/vue-otp.vue";
import CustomerDetails from "./customer-details.vue";
import RicaDetails from "./rica-details.vue";
import Complete from "./complete.vue";
import { USER_LOGIN } from "@/store/actions.type";
import store from "@/store";

import SubscriberService from "@/services/subscriber.service.js";

import SubscriberModel from "@/models/subscriber.model.js";

export default {
  name: "register",
  components: {
    "vue-good-wizard": GoodWizard,
    "vue-otp": VueOtp,
    "customer-details": CustomerDetails,
    "rica-details": RicaDetails,
    "complete": Complete
  },
  data() {
    return {
      is_loading: true,
      otp_response: false,
      subscriber: new SubscriberModel(),
      mobile_number: false,
      registerSteps: [
        {
          slot: "otp"
        },
      ],
      current_page: 0
    };
  },
  computed: {
    isLoading() {
      return store.state.products.is_loading;
    }
  },
  beforeMount() {
    var self = this;
    self.registerListeners();
  },
  mounted() {},
  methods: {
    validOtp(response) {
      const self = this;
      self.$log.debug("validOtp", response);
      if(response && response.success) {
        switch(response.data.account_type){
          case "Test":
          case "Affinity":
            self.resetSubscriber();            
            self.registerSteps.push({slot:"customer-details"});
            self.registerSteps.push({slot:"rica-details"});            
            break;          
        }   
        self.registerSteps.push({slot:"complete"});     

        self.otp_response = response.data;                
        self.mobile_number = self.otp_response.msisdn;
        self.subscriber.id = self.otp_response.order_id;
        self.subscriber.mobile_number = self.mobile_number;

        self.nextStep(response);
      }      
    },
    updateSubscriber(response) {
      const self = this;
      if(response){
        EventBus.$emit("global_loading", { is_loading: true });
        SubscriberService.updateSubscriber(self.subscriber)
          .then(function({ data }) {          
            EventBus.$emit("global_loading", { is_loading: false });
            self.nextStep(data.success);
          })
          .catch(function({ response }) {
            self.$log.error("Error saving subscirber", response);
            self.has_error = true;
            self.display_message = true;
            self.message = "Error saving. Please contact support.";
            EventBus.$emit("global_loading", { is_loading: false });
          });
      }
    },
    ricaSubscriber() {
      const self = this;
      self.nextStep(true);      
    },
    completeRegistration(details) {
      const self = this;
      store.dispatch(USER_LOGIN, {
        username: details.user_name,
        password: details.password,
        redirect: details.redirect
      });
      self.nextStep(true);      
    },
    resetSubscriber(){
      const self = this;
      self.subscriber = new SubscriberModel();
    },
    nextClick(currentPage) {
      var self = this;
      self.current_page = currentPage;
    },
    backClick(currentPage) {
      var self = this;
      self.current_page = currentPage;
    },
    registerListeners() {},
    nextStep(goNext) {
      var self = this;
      self.$refs.wizard.goNext(goNext);
    },
    cancel(is_cancel) {
      var self = this;
      self.$log.debug("wizard cancel");
      if (is_cancel) self.$refs.wizard.goTo(0);
    },
    back() {
      var self = this;
      if (self.current_page > 0) self.$refs.wizard.goTo(self.current_page - 1);
    }
  }
};
</script>